import { useQuery } from '@tanstack/react-query';

import { useCurrentScope } from '../../../shared/scope/useCurrentScope.js';

import {
  getTaskById,
  getTaskDetailQueryKey,
  getTasksQueryKey,
  listTasks,
  type ListTasksFilters,
} from '../api/tasks.client.js';

export function useTasks(filters: ListTasksFilters = {}) {
  const scope = useCurrentScope();
  const workspaceId = scope?.workspaceId ?? 'anonymous';

  return useQuery({
    queryKey: getTasksQueryKey(workspaceId, filters),
    queryFn: () => listTasks(filters),
    enabled: scope !== null,
  });
}

export function useTask(taskId: string) {
  const scope = useCurrentScope();
  const workspaceId = scope?.workspaceId ?? 'anonymous';

  return useQuery({
    queryKey: getTaskDetailQueryKey(workspaceId, taskId),
    queryFn: () => getTaskById(taskId),
    enabled: scope !== null && taskId.length > 0,
  });
}
